<template>
    <div >
        <a-spin :spinning="loading">
            <div style="display:flex;justify-content: start;margin-top: 5px;font-size:15px; color: black;">
                Upload Product Image
            </div>
            <span style="color: #6B7280;font-size:12px" >Listings that are missing a main image will not appear in search or browse until you fix the listing
                <br>
                Chose images that are clear, information-rich and attractive.</span>
            <div style="margin-top: 10px;font-size:21px;">
                <a-row>
                    <a-form-model-item label="Upload Product Image" ref="image" prop="image">
                    <div class="clearfix">
                        <a-upload
                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                        list-type="picture-card"
                        :file-list="fileList"
                        @preview="handlePreview"
                        @change="handleChange"
                        :remove="handleRemove"
                        :beforeUpload="beforeUpload"
                        class="upload"
                        >
                        <div>
                            <a-icon type="plus" />
                            <div class="ant-upload-text">
                            Upload
                            </div>
                        </div>
                        </a-upload>
                        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                            <img alt="example" style="width: 100%" :src="previewImage" />
                        
                            <!-- <check-box :value="selectedValue" :msg="msg" @change="changeValue" :file="fileSelected"></check-box> -->
                            <h4 style="display:flex;justify-content: center;margin-top:15px">Image Name:  <span style="margin-left:10px">{{fileSelected.name}}</span></h4>
                            <div style="display:flex;justify-content: center;">
                                
                                <a-button @click="selectedImage" style="background: #418a49;height:45px;color:#fff;width:256px;margin-top: 28px;">
                                    Make Image as Main Image
                                </a-button>
                            </div>
                        </a-modal>
                        
                    </div>
                </a-form-model-item>
                </a-row>
                <div style="display:flex;justify-content: start;">
                    <a-button @click="saveProductImageInfo" style="background: #418a49;color:#fff;margin-right: 15px;">
                        Save
                    </a-button>

                     <!-- <a-button @click="skipProductImage" style="background: #418a49;color:#fff;">
                        Skip
                    </a-button> -->

                </div>
            </div>

        </a-spin>
        
        
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import CheckBox from './CheckBox'
import _ from 'lodash';
// import axios from 'axios'


function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

    export default {
        name:"EditProductImage",
        // components:{
        //     CheckBox
        // },
        data(){
            return {
                loading: false,
                fileList:[],
                previewVisible: false,
                previewImage: '',
                imgSelected:false,
                fileSelected:{},
                selectedValue:"",
                newFilelist:[],
                productDetails:{},
                // msg:"Make Image as Main Image"

            }
        },
        computed: mapGetters(['getProductDetailsInfo', 'getCatalog']),
        methods:{
            ...mapActions(['setStepCount','uploadProductImage','deleteProductImage','getAllProductById']),
            
            handleRemove(file) {
                // console.log("removing file | ", file)
                let request_data = {
                    ProductId: file.productId,
                    ImageId: file.id
                }

                this.deleteProductImage(request_data)
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
                // console.log("fileList delete | ", this.fileList)

            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },

            selectedImage(){
                // console.log("file | ", this.fileSelected)
                this.showSuccessAlert(`Image [ ${this.fileSelected.name} ] is selected as main image`);
                this.previewVisible = false;
                
            },

            handleChange({ fileList }) {
                
                this.fileList = fileList;
            },
            handleCancel() {
                this.previewVisible = false;
            },

            beforeUpload(file) {
                // console.log("file type | ", file.type)
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                
                if (!isJpgOrPng) {
                    this.fileList = [];
                    this.showErrorAlert("You can only upload PNG or JPEG file!")
                    // console.log("fileList not png | ", this.fileList)
                    return false;
                }else{
                    // console.log("fileList png | ", this.fileList)
                    this.fileList = [...this.fileList, file];
                    return false;
                }
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                // console.log("file | ", file)
                this.fileSelected = file
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },

            skipProductImage(){
                // this.setStepCount(3)
                // this.$router.push(`/edit-inventory-details`).catch(()=>{});
            },

            saveProductImageInfo(){
                // console.log("fileSelected | ", this.fileSelected)
                // console.log("fileList | ", this.fileList)
                let existImages = [];
                this.fileList.forEach(image => {
                    if(!image.exist){
                        existImages.push(image)
                    }
                })
                // console.log("existImages | ", _.isEmpty(existImages))
                if(_.isEmpty(existImages)){
                    this.showErrorAlert("Image(s) already exist, kindly choose a different one")
                }else{
                    if(_.isEmpty(this.fileSelected)){
                        this.showErrorAlert("Kindly upload and set one of the image(s) as main image")
                    }else{
                        // this.loading = true;
                        this.fileList = this.fileList.map(file => {
                            if(file.uid === this.fileSelected.uid){
                                return {
                                    file: file,
                                    IsPrimary: true
                                }
                            }
                            return {
                                file: file,
                                IsPrimary: false
                            }
                        })
                    
                        // console.log("fileList | ", this.fileList)
                        //  console.log("productid| ", this.productDetails.productId)

                        this.fileList.forEach(file => {
                            // console.log("file | ", file)
                            let formData = new FormData();
                            // console.log("originFileObj | ", file.file.originFileObj)
                            formData.append('Image', file.file.originFileObj);
                            let request_file_data = {
                                ProductId:this.getCatalog.id,
                                formData:formData,
                                IsPrimary: file.IsPrimary
                            }
                            
                            this.uploadProductImage(request_file_data).then(() => {},
                            error =>{
                                console.log("Error | ", error)
                                this.showErrorAlert(JSON.stringify(error))
                            })
                        });   

                        // this.loading = false;   
                        this.fileSelected = {}                     
                        this.fileList = [];
                    
                        // console.log("fileList | ", this.fileList)
                        this.setStepCount(3)
                        // this.$router.push(`/edit-inventory-details`).catch(()=>{});
                    }
                }
               
                
            },
            randomString(length) {
                return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
            },
            
        },
        created(){
            // if(this.getProductDetailsInfo){
            //     // console.log("getProductDetailsInfo in add image | ", this.getProductDetailsInfo)
            //     this.productDetails = this.getProductDetailsInfo
            // }
            if(this.getCatalog){
                // console.log("getCatalog | ", this.getCatalog)

                this.getAllProductById(this.getCatalog.id).then(response => {
                    
                    // console.log("fileList | ", this.fileList)
                    if(response.status === 200){
                        this.fileList = response.data.imageUrls.map(image => {
                            let ImageName = image.imageUrl.split("/")
                            return {
                                uid: this.randomString(10),
                                name: `${ImageName[2]}`,
                                status: 'done',
                                id: image.id,
                                productId: this.getCatalog.id,
                                exist: true,
                                url: `${process.env.VUE_APP_IMAGE_BASE_URL}/${image.imageUrl}`,
                    
                            }
                        })
                    }else{
                        // console.log("Error | ", response)
                    }
                })
            }
        }
    }
</script>

<style scoped>
.img_size{
    max-width: 56px;
    max-height: 55px;
}
.upload-list-inline >>> .ant-upload-list-item {
  float: left;
  width: 200px;
  margin-right: 8px;
}
.upload-list-inline >>> .ant-upload-animate-enter {
  animation-name: uploadAnimateInlineIn;
}
.upload-list-inline >>> .ant-upload-animate-leave {
  animation-name: uploadAnimateInlineOut;
}
.upload >>> .ant-upload-list-item-actions a{
    margin-right: 18px;
}
</style>